<template lang="html">
  <svg
    :width="width"
    :height="height"
    :fill="color"
    viewBox="0 0 32.192 26.476"
  ><defs></defs><g transform="translate(0 0)"><g transform="translate(-3.003 -7)"><path d="M33.3,25.938H29.514A12.31,12.31,0,0,0,19.1,7H15.31A12.31,12.31,0,0,0,9.146,29.963a.881.881,0,0,0,.473.133.947.947,0,0,0,.473-1.771,10.416,10.416,0,1,1,13.579-2.841.871.871,0,0,0-.161.417H16.257a1.894,1.894,0,0,0-1.894,1.894v3.788a1.894,1.894,0,0,0,1.894,1.894H33.3A1.894,1.894,0,0,0,35.2,31.582v-3.75A1.894,1.894,0,0,0,33.3,25.938Zm-3.788,1.894V31.62H25.726V27.832Zm-3.788-1.894a11.941,11.941,0,0,0,1.61-3.788h1.828a10.359,10.359,0,0,1-1.657,3.371.871.871,0,0,0-.161.417Zm3.788-6.628a6.283,6.283,0,0,1-.047.947H27.62V19.31a12.31,12.31,0,0,0-.947-4.735h1.695A10.34,10.34,0,0,1,29.514,19.31ZM22.886,9.6a10.416,10.416,0,0,1,4.242,3.078H25.67A12.31,12.31,0,0,0,22.886,9.6ZM16.257,27.832h1.894v.947a.947.947,0,0,0,1.894,0v-.947h3.788V31.62H16.257ZM33.3,31.62H31.408V27.832H33.3Z" transform="translate(0 0)"/><path d="M11.735,16.894a2.841,2.841,0,0,1,.8.114.947.947,0,0,0,.53-1.818A4.839,4.839,0,0,0,11.735,15a4.735,4.735,0,1,0,4.735,4.735,2.841,2.841,0,1,1,2.036,2.727.947.947,0,0,0-.53,1.818,4.839,4.839,0,0,0,1.335.189,4.735,4.735,0,1,0-4.735-4.735,2.841,2.841,0,1,1-2.841-2.841Z" transform="translate(-0.212 -0.425)"/></g></g></svg>
</template>

<script>
  import mixinIcons from '../mixins/mixin-icons.js'

  export default {
    mixins: [
      mixinIcons
    ]
  };
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/icons/TokensIcon.vue